import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { LearnedPresetKind } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";

export const UsedParcelLearningCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Used package learning",
    cell: (group) =>
      group.usedLearning?.[LearnedPresetKind.PARCEL] ? "Yes" : "No",
  };
